import { render, staticRenderFns } from "./UploadWallpaperStepThree.vue?vue&type=template&id=2790bb41&scoped=true&"
import script from "./UploadWallpaperStepThree.vue?vue&type=script&lang=js&"
export * from "./UploadWallpaperStepThree.vue?vue&type=script&lang=js&"
import style0 from "./UploadWallpaperStepThree.vue?vue&type=style&index=0&id=2790bb41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2790bb41",
  null
  
)

export default component.exports